import Controller from '@ember/controller';
import DS from 'ember-data';
import { action } from '@ember/object';
import SqlImportModel, { ImportStatus } from 'cio/models/sql-import';
import AnalyticsService from 'cio/services/analytics';
import EnvironmentService from 'cio/services/environment';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import RouterService from '@ember/routing/router-service';
import { tracked } from '@glimmer/tracking';
import ApiErrorsService from 'cio/services/api-errors';
import { SqlImportDatabase, SqlImportsCreateStep } from 'cio/utils/sql-import';
import { isEmpty } from '@ember/utils';
import ShortSegmentModel from 'cio/models/short-segment';
import SqlImportDatabaseModel from 'cio/models/sql-import-database';
import Ember from 'ember';
import isDestroyed from 'cio/utils/is-destroyed';

export default class SqlImportsNewController extends Controller {
  @service analytics!: AnalyticsService;
  @service router!: RouterService;
  @service apiErrors!: ApiErrorsService;
  @service environment!: EnvironmentService;
  @service store!: DS.Store;

  @tracked sqlImport?: SqlImportModel;
  @tracked id?: number;

  queryParams = ['id'];

  declare model: {
    type: SqlImportDatabase;
    sqlImport: SqlImportModel;
    sqlImportDatabases: SqlImportDatabaseModel;
    segments: ShortSegmentModel;
  };

  get isDirty() {
    if (isDestroyed(this) || isDestroyed(this.model.sqlImport)) {
      return false;
    }
    return (
      (this.model.sqlImport?.hasDirtyAttributes as Ember.ComputedProperty<boolean>) &&
      !isEmpty(this.model.sqlImport.name)
    );
  }

  @action
  reset() {
    if (this.model.sqlImport?.get('isNew')) {
      this.model.sqlImport?.unloadRecord();
    } else {
      this.model.sqlImport?.rollbackAttributes();
    }
  }

  saveTask = dropTask(async (step?: SqlImportsCreateStep) => {
    try {
      if (step === SqlImportsCreateStep.Review) {
        this.analytics.track('sql_imports', 'create_sync_started', { model: this.sqlImport });
        this.model.sqlImport?.set('ImportStatus', ImportStatus.Published);
      }
      await this.model.sqlImport?.save();
      this.router.transitionTo('sql-imports.import', this.model.sqlImport?.id);
    } catch (err) {
      this.apiErrors.report(err);
    }
  });

  @action
  setDefaults() {
    this.id = undefined;

    this.reset();
  }
}
